<a class="primary" [href]="util.studentDashboardUrl">
  <ng-content></ng-content>
</a>
